import { render } from "./TableOrder.vue?vue&type=template&id=2b74aa24"
import script from "./TableOrder.vue?vue&type=script&lang=ts"
export * from "./TableOrder.vue?vue&type=script&lang=ts"
script.render = render

export default script